import { render } from "./AiChatBanner.vue?vue&type=template&id=597403dd&scoped=true"
import script from "./AiChatBanner.vue?vue&type=script&lang=js"
export * from "./AiChatBanner.vue?vue&type=script&lang=js"

import "./AiChatBanner.vue?vue&type=style&index=0&id=597403dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597403dd"]])

export default __exports__